import { Component, OnInit, Input } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, FormControlName } from '@angular/forms';
import {AppComponent} from '../../app.component';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import { AlertService } from '../../alertpopup/_alert';
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export type Config = {
  multi?: boolean
};
export type Menu = {
  name: string,
  active: boolean,
  submenu: {
    captionName: string;
    controlName: string;
    controlName2: string;
    controlType: string;
    placeholder?: string;
    selectedValue?: string;
    selectedValue2?: string;
    selectedValue3: [];
    options?: Array<{
      optionName: string;
      value: string;
    }>;
    validators?: {
      required?: boolean;
      minlength?: number;
      maxlength?: number;
    };
   }[]
}

@Component({
    selector: 'app-role-policies',
    templateUrl: './role-policies.component.html',
    styleUrls: ['./role-policies.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class RolePoliciesComponent implements OnInit {
  @Input() options;
  @Input() menus: Menu[];
  config: Config;
  url: string;
  DownloadURL: string;
  PageStatus: string;
  form: FormGroup;
  submitted: boolean;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2030, 0, 1);
  buttonName: string;
  ID: any;
  editable: boolean;
  SelectedValue: any;
  SelectedValue2: any;
  SelectedValue3: [];
  option = {
    autoClose: true,
    keepAfterRouteChange: false
};
  @Input() formData: Menu[];

  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService ) {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }
  ngOnInit() {
    const formGroup = {};
    this.form = new FormGroup(formGroup);
    this.buttonName = "View";
    this.http.get(this.url + 'SysData/FetchRulePolicyData')
    .subscribe( (res) =>   {
        if (res == null) {
        } else {
          this.formData = JSON.parse(res.toString());
                           console.log(JSON.parse(res.toString()));
                           this.formData.forEach(formControl => {
                            formControl.submenu.forEach(formControl1 => {
                            formGroup[formControl1.controlName] = new FormControl("");
                            console.log("data"+formControl1.controlName);
                            if (formControl1.controlName2!= "") {
                              formGroup[formControl1.controlName2]= new FormControl(""); }
                            this.form = new FormGroup(formGroup);
                          });
                          });


                            this.formData.forEach(formControl => {
                              formControl.submenu.forEach(val => {
                                if (val.controlType == "DTP2") { if (this.SelectedValue == "") {
                                  let date: Date = new Date();
                                  this.SelectedValue = date;
                                  this.SelectedValue2 = date; }
                                 }
                             this.SelectedValue = val.selectedValue;
                             this.SelectedValue2 = val.selectedValue2;
                             this.SelectedValue3 = val.selectedValue3;

                             (this.form.get(val.controlName) as FormControl).patchValue(this.SelectedValue);
                             if (val.controlName2 != "") {
                              (this.form.get(val.controlName2) as FormControl).patchValue(this.SelectedValue2); }
                             if (val.controlType == "HLP") {
                               (this.form.get(val.controlName) as FormControl).patchValue(this.SelectedValue3);
                               }
                              });
                            });
        }
       }
    );
    this.options= { multi: false };
    this.config = this.mergeConfig(this.options);
  }

  mergeConfig(options: Config) {
    const config = {
      multi: true
    };
    return { ...config, ...options };
  }

  toggle(index: number) {
    if (!this.config.multi) {
        this.formData.filter(
          (menu, i) => i !== index && menu.active
          ).forEach(menu => menu.active = menu.active);
    }
    this.formData[index].active = !this.formData[index].active;
  }
  submitForm() {
    console.log(this.form.value);
    this.http.post(this.url + 'SysData/InsertUpdateRulePolicy', this.form.value).subscribe( (data) =>   {
          if (data == null) {
            this.alertService.showError('Check Your InterNet Connection, Try Again Later');
          }
          else{
            this.alertService.showSuccess(data.toString());
          }
         }
      );
    }
}
